import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/index.less'
import './assets/fonts/iconfont.css'
import 'default-passive-events' // 解决警告
import Common from './assets/common'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import deLocale from 'element-ui/lib/locale/lang/de'

// 富文本编辑器
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// Vue.use(VueQuillEditor)


import translate from 'i18n-jsautotranslate';
 

 
// 是否显示语言切换栏
translate.selectLanguageTag.show = false;
 translate.service.use('client.edge'); //设置机器翻译服务通道，相关说明参考 http://translate.zvo.cn/545867.html

// 监控页面动态渲染的文本进行自动翻译
translate.listener.start(); 
//  translate.execute();//完成翻译初始化，进行翻译
// Vue 2
// translate.service.use('client.edge');
Vue.prototype.$translate = translate;



Vue.use(VueI18n)
// Vue.use(Element, {
//   size: 'medium', // set element-ui default size设置元素默认大小
//   i18n: (key, value) => i18n.t(key, value)// 在注册Element时设置i18n的处理方法
// })
// Vue.use(Element, {
//   i18n: function (path, options) {
//     // ...
//   }
// })
const i18n = new VueI18n({
  locale: 'zh', // 语言标识
  messages: {
    'zh': require('./assets/lang/zh'),
    'en': require('./assets/lang/en'),
    'de': require('./assets/lang/de')
  }
})

import '../rem.js'
import axios from 'axios'
Vue.prototype.$http= axios
Vue.use(ElementUI);


// 全局方法挂载
Vue.prototype.common = Common;



Vue.filter(
  //角色类型
  'fitUp', function (status) {
  const statusMap = {
    '0': '否',
    '1': '是',

    }
    return statusMap[status]
    
} )
Vue.filter(
  //角色类型
  'tarr', function (status) {
  const statusMap = {
    '0': '出售',
    '1': '求购',

    }
    return statusMap[status]
    
} )
Vue.filter(
  //角色类型
  'category', function (status) {
  const statusMap = {
    '1': '政策法规',
    '2': '行业动态',
    '3': '太一资讯',

    }
    return statusMap[status]
    
} )
Vue.filter(
  //保留一位小数
  'blyw', function (val) {
    val = Math.round(val * 10) / 10
    var xsd = val.toString().split('.')
    if (xsd.length === 1) {
      val = val.toString() + '.0'
      return val
    }
    return val
  

    
} )
Vue.filter(
  //角色类型
  'sellstatus', function (status) {
  const statusMap = {
    '1': '未售出',
    '2': '已售出'
    }
    return statusMap[status]
    
} )
Vue.filter(
  //角色类型
  'autone', function (status) {
  let a = status.substring(0, 1)
    return a
    
} )
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

/* 
  使用的插件
  @riophae/vue-treeselect

 */
